import { message } from 'antd'
import axios from 'axios'
import { useCallback, useState } from 'react'

import { BASE_URL } from '../../../ini.json'
import { useAppSelector } from '../../redux/hooks'

interface UseDeleteZustavateRecordResult {
  deleteRecord: (id: string) => Promise<boolean>
  isDeleting: boolean
}

export const useDeleteZustavateRecord = (): UseDeleteZustavateRecordResult => {
  const [isDeleting, setIsDeleting] = useState(false)
  const token = useAppSelector(state => state.myProfile.token)

  const deleteRecord = useCallback(
    async (id: string): Promise<boolean> => {
      if (!token) {
        message.error('Nejste přihlášený')
        return false
      }

      setIsDeleting(true)

      try {
        const response = await axios.post(
          `${BASE_URL}/api/zustavate/update/${token}`,
          { id, delete: true }
        )

        if (response.data.success) {
          message.success('Záznam byl úspěšně smazán')
          return true
        } else {
          throw new Error()
        }
      } catch (error) {
        message.error('Nepodařilo se smazat záznam')
        return false
      } finally {
        setIsDeleting(false)
      }
    },
    [token]
  )

  return { deleteRecord, isDeleting }
}
